// /app/javascript/controllers/order_summary_controller.js
import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

export default class extends Controller {
  static values = {
    // The subtotal value is no longer needed for client-side calculations
    updateUrl: String
  }

  /**
   * This action is triggered when the shipping method select dropdown is changed.
   * It updates a hidden field in the main checkout form and then submits
   * that form's data to the server to get an updated order summary.
   */
  updateShipping(event) {
    const selectedShippingMethod = event.target.value;
    const checkoutForm = document.getElementById("checkout-form");

    if (!checkoutForm) {
      console.error("Could not find the checkout form with id='checkout-form'");
      return;
    }

    // Find the hidden field for shipping_method within the main form
    const hiddenShippingInput = checkoutForm.querySelector('input[name="invoice[shipping_method]"]');

    if (hiddenShippingInput) {
      hiddenShippingInput.value = selectedShippingMethod;

      // Submit the entire form's data to get an updated summary
      const formData = new FormData(checkoutForm);

      post(this.updateUrlValue, {
        body: formData,
        responseKind: "turbo-stream"
      });

    } else {
      console.error("Could not find the hidden shipping method field in the checkout form.");
    }
  }
}